import { render, staticRenderFns } from "./bibliometric_analysis.vue?vue&type=template&id=ce94658c&scoped=true"
import script from "./bibliometric_analysis.vue?vue&type=script&lang=js"
export * from "./bibliometric_analysis.vue?vue&type=script&lang=js"
import style0 from "./bibliometric_analysis.vue?vue&type=style&index=0&id=ce94658c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce94658c",
  null
  
)

export default component.exports